export const BASE_URL = 'https://villagezone.shop';
export const PRODUCTS_URL = `${BASE_URL}/api/v2/products/search`;
export const PRODUCT_URL = `${BASE_URL}/api/products/product`;
export const SLUG_PRODUCT_URL = `${BASE_URL}/api/products/product/slug`;
export const USER_URL = `${BASE_URL}/api/auth/user`;
export const ADDRESS_URL = `${BASE_URL}/api/auth/address`;
export const CREATE_ADDRESS_URL = `${BASE_URL}/api/auth/createAddress`;
export const DELETE_ADDRESS_URL = `${BASE_URL}/api/auth/deleteAddress`;
export const LOGIN_URL = `${BASE_URL}/api/auth/login`;
export const LOGOUT_URL = `${BASE_URL}/api/auth/logout`;
export const REGISTER_URL = `${BASE_URL}/api/auth/register`;
export const IMAGE_URL = `${BASE_URL}/images`;
export const COUNTRY_URL = `${BASE_URL}/api/countries`;
export const STATE_URL = `${BASE_URL}/api/states`;
export const DISTRICT_URL = `${BASE_URL}/api/districts`;
export const CREATE_ORDER_URL = `${BASE_URL}/api/v3/auth/orders/store`;
export const LIST_ORDERS_URL = `${BASE_URL}/api/v2/auth/orders/list`;
export const VIEW_ORDERS_URL = `${BASE_URL}/api/auth/orders`;
export const TRACK_ORDERS_URL = `${BASE_URL}/api/v2/auth/delivery/track`;
export const VERIFY_PAYMENT = `${BASE_URL}/api/v2/auth/orders/razorpayVerification`;
export const CANCEL_ORDER = `${BASE_URL}/api/v2/auth/orders/cancelPayment`;
export const PRODUCT_CATEGORIES_URL = `${BASE_URL}/api/v2/products/subcategories`;
export const VENDORS_URL = `${BASE_URL}/api/v2/products/vendors`;
export const GET_REVIEWS_URL = `${BASE_URL}/api/products/review`;
export const REVIEW_URL = `${BASE_URL}/api/auth/review`;
export const FORGOT_PASSWORD_URL = `${BASE_URL}/api/auth/forgot-otp`;
export const RESET_PASSWORD_URL = `${BASE_URL}/api/auth/reset-password`;
export const DELETE_USER_URL = `${BASE_URL}/api/auth/delete-user`;
export const APPLY_COUPON = `${BASE_URL}/api/v2/auth/coupons/apply`;
export const CHECK_DELIVERY_URL = `${BASE_URL}/api/v2/auth/orders/check-shipping`;


